import { AbstractSymbol } from "../../../../abstracts/elements/AbstractSymbol";
import { log } from "../../../../abstracts/utils/AbstractConsole";
import { symbolsArray } from "../../../UCConfig";
import { UCSymbolNames } from "../../../types/UCEnums";
import { UCBigFishSymbol } from "./UCBigFishSymbol";
import { UCMysterySymbol } from "./UCMysterySymbol";
import { UCScatterSymbol } from "./UCScatterSymbol";
import { UCSymbol } from "./UCSymbol";
import { UCWildSymbol } from "./UCWildSymbol";

export class UCSymbolPool {
    private symbolName: string;
    private pool: AbstractSymbol[] = [];

    constructor(symbolName: string) {
        this.symbolName = symbolName;
    }

    public getSymbol(): AbstractSymbol {
        let symbol: AbstractSymbol | undefined = this.pool.shift();

        if (symbol === undefined) {
            switch (this.symbolName) {
                case UCSymbolNames.MYSTERY:
                    symbol = new UCMysterySymbol();
                    break;

                case UCSymbolNames.WILD:
                    symbol = new UCWildSymbol();
                    break;

                case UCSymbolNames.BIG_FISH:
                    symbol = new UCBigFishSymbol();
                    break;

                case UCSymbolNames.SCATTER:
                    symbol = new UCScatterSymbol();
                    break;

                default:
                    symbol = new UCSymbol(this.symbolName);
            }
        }

        return symbol;
    }

    public returnSymbol(symbol: AbstractSymbol) {
        symbol.reset();
        symbol.parent?.removeChild(symbol);

        this.pool.push(symbol);
    }
}

const poolsMap: { [k: string]: any } = {};

[...symbolsArray].forEach((symbolName: string) => {
    poolsMap[symbolName] = new UCSymbolPool(symbolName);
});

export const getSymbolFromPool = (name: string): AbstractSymbol => {
    if (!poolsMap[name]) {
        log(`Texture for symbol ${name} does not exist!`);
    }

    return poolsMap[name].getSymbol()!;
};
export const returnSymbolToPool = (symbol: AbstractSymbol) =>
    poolsMap[symbol.name].returnSymbol(symbol);
